import React from 'react';
import { AuthProvider } from './src/context/AuthContext';

import 'bootstrap/dist/js/bootstrap';

export const wrapRootElement = ({ element }) => (
  <AuthProvider>{element}</AuthProvider>
)